import { CallState } from '../../../features/call/call.types';

export const getIsCallLeaving = (callState: CallState): boolean =>
  callState === CallState.LeavingAfterError ||
  callState === CallState.PhoneCallLeavingAfterError ||
  callState === CallState.PhoneCallLeaving ||
  callState === CallState.Leaving ||
  callState === CallState.TestCallLeaving ||
  callState === CallState.TestCallLeavingAfterError;
